/**
 * Color Drop Zone Element
 * Interactive element: background image with hotspot zones, draggable objects with color selection
 */

import * as React from 'react';
import type { ElementDefinition } from '@ai-content-hub/content-kit';
import {
    colorDropZoneElementSchema,
    type ColorDropZoneElementData,
    type ColorDropZoneAnswer,
    type DropZoneHotspot,
    type DropZoneObject,
    type ColorOption,
} from './schema';
import { ColorDropZoneEdit } from './ColorDropZoneEdit';
import { ColorDropZonePlayer } from './ColorDropZonePlayer';
import { colorDropZoneGrader } from './grader';

export {
    colorDropZoneElementSchema,
    type ColorDropZoneElementData,
    type ColorDropZoneAnswer,
    type DropZoneHotspot,
    type DropZoneObject,
    type ColorOption,
};

export {
    normalizeColorDropZoneData,
    getBackgroundImageSrc,
    getBackgroundImageAlt,
    createDefaultHotspot,
    createDefaultColorOption,
    createDefaultDropZoneObject,
} from './schema';

export { ColorDropZoneEdit };
export { ColorDropZonePlayer };
export { colorDropZoneGrader };

export const colorDropZoneElement: ElementDefinition<
    ColorDropZoneElementData,
    ColorDropZoneAnswer
> = {
    schema: colorDropZoneElementSchema,
    EditComponent: ColorDropZoneEdit as React.ComponentType<any>,
    PlayerComponent: ColorDropZonePlayer as React.ComponentType<any>,
    grader: colorDropZoneGrader,
    validator: {
        validate: colorDropZoneGrader.validate!,
    },
};
